import { SalaryBatch } from "../../../models/Salary";

/**
 * One-line summary of what a batch was scoped to, for the batch list.
 *
 * Only counts per group — resolving ids to names would mean loading the
 * subsidiary taxonomy just to label a list column. Batches created before
 * consultant filtering fall back to the deprecated single `pool`.
 */
export function describeSalaryBatchScope(
	salaryBatch: Pick<SalaryBatch, "filter" | "pool">,
	t: (key: string) => string
) {
	const { filter, pool } = salaryBatch;

	if (!filter) return pool || t("ALL");

	const parts = [
		filter.pools?.length && `${t("POOL")}: ${filter.pools.length}`,
		filter.subsidiaryIds?.length && `${t("SUBSIDIARY")}: ${filter.subsidiaryIds.length}`,
	].filter(Boolean);

	return parts.length ? parts.join(" · ") : pool || t("ALL");
}
